<template>
  <div class="mobile-top">

    <home-tour v-if="$store.state.tour && !this.$store.getters.hideOrders" />
    <home-tour-no-orders v-else-if="$store.state.tour && this.$store.getters.hideOrders" />


    <!-- ################### START HERO ################### -->
    <section id="v-step-6" class="pt-5" style="
        background-size: cover;
        background-position: right;
        background-repeat: no-repeat;
        position: relative;
        padding-bottom: 20px;
        background-image: url('/img/headerbg2.svg');
      ">
      <div class="container">
        <!-- ################### SEARCH BAR ################### -->
        <div v-if="!this.$store.getters.hideOrders" class="new-search mb20 bs-shadow">
          <div class="search-wrap" style="border-radius: 8px;">
            <div class="input-group">
              <input v-model="searchValue" @keyup.enter.prevent="searchOrder" type="text" class="form-control"
                aria-label="Amount (to the nearest dollar)" style="
                  padding: 12px;
                  background: rgb(232 238 241);
                  border: none;
                " placeholder="Search listings by order number, PO number, or order name..." />
              <div class="input-group-append">
                <span @click="clearSearch" class="input-group-text new-search-btn2">
                  <span class="material-icons">find_replace</span>
                  {{ " " }} Clear
                </span>

                <span @click="searchOrder" class="input-group-text new-search-btn1">
                  <span class="material-icons">search</span>
                  {{ " " }}Search
                </span>
              </div>
            </div>
            <!-- input group -->
          </div>
          <!-- search wrap -->
        </div>
        <!-- conditional search bar -->
        <!-- ################### END SEARCH BAR ################### -->

        <!-- ################### REPORTS CARDS ################### -->
        <!--
        <div v-if="reportLoading && this.$store.getters.isReports" style="
        height: 144.79px; 
        display: flex;
        align-items: center;
        justify-content: center;">
        <div class="flex-box-wrap">
          <div class="flex-internal">
            <atom-spinner
              :animation-duration="1000"
              :size="40"
              :color="'#6c757d'"
            />
            <p style="color: #6c757d">Loading......</p>
          </div>
        </div>
        </div>
         -->
        <!--
          <HomeReports
          v-if="reportLoading && this.$store.getters.isReports"
        /> 
        -->

        <HomeReports v-if="!reportLoading && this.$store.getters.isReports && homeReports"
          :homeReports="homeReports.homeReports" :loading="reportLoading" />

        <!-- ################### END REPORTS CARDS ################### -->

        <!-- ################### ORDER, ACK and INVOICE CARDS ################### -->
        <div v-if="
          this.$store.getters.isACKSnINVS && !this.$store.getters.hideOrders
        " class="row clearfix">
          <div class="col-md-12 col-lg-4">
            <router-link to="/listings" style="color: #fff; text-decoration: none; flex: 1 1 100%">
              <div class="card dashboard-card2 bs-shadow mb20" style="width: 100%">
                <div class="body p-4">
                  <div class="row clearfix">
                    <div class="col-auto">
                      <div class="stamp stamp-md teal-bg">
                        <img src="@/assets/img/funds-box-fill-white.svg" />
                      </div>
                    </div>
                    <div class="col text-right">
                      <div class="small text-muted">Orders</div>
                      <div v-if="homeAlerts" class="h3 m-0" style="color: #575757">
                        {{ homeAlerts.totals.orders }}
                      </div>
                      <div v-else-if="listings && listings.length == 0" class="h3 m-0" style="color: #575757">
                        {{ listings.length }}
                      </div>
                      <div v-else class="h3 m-0" style="color: #575757">
                        ....
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="col-md-12 col-lg-4">
            <router-link to="/acknowledgments" style="color: #fff; text-decoration: none; flex: 1 1 100%">
              <div class="card dashboard-card2 bs-shadow mb20">
                <div class="body p-4">
                  <div class="row clearfix">
                    <div class="col-auto">
                      <div class="stamp stamp-md orange-bg">
                        <img src="@/assets/img/draft-fill-white.svg" />
                        <!--  <i class="fas fa-file"></i> -->
                      </div>
                    </div>
                    <div class="col text-right">
                      <div class="small text-muted">Acknowledgments</div>
                      <div v-if="homeAlerts" class="h3 m-0" style="color: #575757">
                        {{ homeAlerts.totals.acknowledgments }}
                      </div>
                      <div v-else class="h3 m-0" style="color: #575757">
                        ....
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="col-md-12 col-lg-4">
            <router-link to="/invoices" style="color: #fff; text-decoration: none; flex: 1 1 100%">
              <div class="card dashboard-card2 bs-shadow mb20">
                <div class="body p-4">
                  <div class="row clearfix">
                    <div class="col-auto">
                      <div class="stamp stamp-md fortbg1">
                        <img src="@/assets/img/article-fill-white.svg" />
                        <!--      <i class="fas fa-file"></i> -->
                      </div>
                    </div>
                    <div class="col text-right">
                      <div class="small text-muted">Invoices</div>
                      <div v-if="homeAlerts" class="h3 m-0" style="color: #575757">
                        {{ homeAlerts.totals.invoices }}
                      </div>

                      <div v-else class="h3 m-0" style="color: #575757">
                        ....
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <!-- ################### END ORDER, ACK and INVOICE CARDS ################### -->

        
        <!-- ################### NEWS SECTION ################### -->

        <div class="row news-row">
  <div class="col-12 col-lg-8 news-col">
    <new-carousel :slides="calcBanners" :loading="newsLoading" />
  </div>

  <div id="newsList" class="col-12 col-lg-4 news-col">
    <div class="panel news-panel">
      <div class="panel-head">
        <h2 class="panel-title">Announcements</h2>
        <router-link to="/announcements" class="panel-link">
          View all <span class="material-icons">arrow_forward</span>
        </router-link>
      </div>

      <!-- Loading -->
      <ul v-if="newsLoading" class="news-list" aria-busy="true">
        <li v-for="n in 5" :key="n" class="news-item">
          <div class="sk sk-date"></div>
          <div class="sk sk-line"></div>
        </li>
      </ul>

      <!-- Empty -->
      <div v-else-if="!calcNewsPosts.length" class="panel-empty">
        <span class="material-icons">campaign</span>
        <p class="mb0">No announcements right now.</p>
      </div>

      <!-- List -->
      <ul v-else class="news-list">
        <li v-for="news in calcNewsPosts.slice(0, 10)" :key="news.id" class="news-item">
          <a
            v-if="news.ExternalLink"
            :href="news.ExternalLink"
            target="_blank"
            rel="noopener noreferrer"
            class="news-link"
          >
            <time :datetime="news.createdAt">{{ $moment(news.createdAt).format("MMM D, YYYY") }}</time>
            <span class="news-title">
              {{ news.title }}
              <span class="material-icons news-ext" aria-label="opens in new tab">open_in_new</span>
            </span>
          </a>
          <router-link v-else :to="`/announcement/${news.id}`" class="news-link">
            <time :datetime="news.createdAt">{{ $moment(news.createdAt).format("MMM D, YYYY") }}</time>
            <span class="news-title">{{ news.title }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</div>

        <!--
           <div class="row row-eq-height">
          <div class="col-lg-8 mb-lg-0">
            <div v-if="newsLoading || !newsPosts.length">
              <new-carousel :slides="sliderLoadingData" />

    
            </div>

            <div v-else>

              <new-carousel :slides="calcBanners" />
            </div>
          </div>


          <div id="newsList" class="col-lg-4 mb-lg-0">
            <div style="
                height: 100%;
                position: absolute;
                overflow: hidden;
                width: calc(100% - 30px);
              ">
        
              <div v-if="newsLoading || !newsPosts.length" class="col-xs-12 col-sm-12 col-12 col-lg-12" style="
                  min-height: 245.06px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-bottom: 30px;
                ">
                <div class="flex-box-wrap">
                  <div class="flex-internal">
                    <atom-spinner :animation-duration="1000" :size="40" :color="'#6c757d'" />
                    <p style="color: #6c757d">Loading......</p>
                  </div>
                </div>
              </div>

              <div v-else class="news-scroll masked-overflow-news">
                <div style="display: flex; flex-direction: column; flex-grow: 1">
                  <div v-for="(news, index) in calcNewsPosts.slice(0, 10)" :key="index" style="flex-grow: 1">
                    <a v-if="news.ExternalLink" :href="news.ExternalLink" target="_blank" rel="noopeneer noreferrer"
                      class="news-roll-item">
                      <p class="top-news-item">

                        <span style="margin-right: 5px; font-size: inherit" class="date-text">{{
                          $moment(news.createdAt).format("MMM Do YYYY") + " - "
                        }}</span>
                        <span class="fw300">{{ news.title }}</span>
                      </p>
                    </a>
                    <router-link v-else :to="/announcement/ + news.id">
                      <p class="top-news-item">

                        <span class="date-text" style="margin-right: 5px; font-size: inherit">{{
                          $moment(news.createdAt).format("MMM Do YYYY") + " - "
                        }}</span>
                        <span>{{ news.title }}</span>
                      </p>
                    </router-link>
                  </div>
                </div>
              </div>

       

              <a v-if="!newsLoading || newsPosts.length"
                style="position: absolute; bottom: 0; left: 0; right: 0; text-decoration: none!important; color: #fff!important;"
                href="/announcements" class="link announcement-link"
              >
                View All
                <i data-v-5a90ec03 class="material-icons">keyboard_arrow_right</i>
              </a>
            </div>
          </div>
        </div>
        
        -->
     
        <FreespanLeaderBoard  :freespanData="freespanData"/>
        <!-- ################### END NEWS SECTION ################### -->
        <home-podcast />
        <home-installs />
        <div class="spacer" style="min-height: 20px"></div>
      </div>
      <img class="top-angle" src="@/assets/img/top-angle2.svg" />
    </section>
    <!-- ################### END HERO ################### -->

    <!-- SECTION -->
     <section id="v-step-7" class="second-banner home-split">
  <div class="container">
    <div class="row">
      <div id="newsFeed" class="col-12 col-lg-6 split-col">
        <div class="panel">
          <div class="panel-head">
            <h2 class="panel-title">Latest Questions</h2>
            <router-link to="/questions" class="panel-link">
              View all <span class="material-icons">arrow_forward</span>
            </router-link>
          </div>

          <!-- Loading -->
          <div v-if="collabLoading" class="q-list" aria-busy="true">
            <div v-for="n in 4" :key="n" class="q-skeleton">
              <div class="sk sk-avatar"></div>
              <div class="sk-lines">
                <div class="sk sk-line"></div>
                <div class="sk sk-line short"></div>
              </div>
            </div>
          </div>

          <!-- Empty -->
          <div v-else-if="!questions.length" class="panel-empty">
            <span class="material-icons">forum</span>
            <p class="mb0">No questions yet. <router-link to="/questions">Start the conversation</router-link></p>
          </div>

          <!-- List -->
          <div v-else class="q-list">
            <home-question
              v-for="q in questions"
              :key="q.Tid"
              :FirstName="q.FirstName"
              :LastName="q.LastName"
              :company="q.Name"
              :Posted="q.Posted"
              :Fname="q.Fname"
              :Subject="q.Subject"
              :Tid="q.Tid"
              :replies="q.replies"
              :Fid="q.Fid"
            />
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6 split-col">
        <FeaturedVideos />
      </div>
    </div>
  </div>
</section>

    <!--
    
      <section id="v-step-7" class="second-banner">
      <div class="container">
        <div class="row row-eq-height">
          <div class="col col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6" id="newsFeed">
            <div style="
                height: 100%;
                min-height: 500px;
                position: absolute;
                overflow: hidden;
                width: calc(100% - 30px);
                padding-bottom: 20px;
              ">
              <div v-if="collabLoading" class="col-xs-12 col-sm-12 col-12 col-md-12 col-lg-12" style="
                  min-height: 302px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-bottom: 3rem !important;
                ">
                <div class="flex-box-wrap">
                  <div class="flex-internal">
                    <atom-spinner :animation-duration="1000" :size="40" :color="'#575757'" />
                    <p style="color: #575757">Loading......</p>
                  </div>
                </div>
              </div>

              <div v-else style="min-height: 562px; max-height: 562px; overflow: scroll"
                class="masked-overflow-collaborate">
                <div v-bind:key="question.Tid" v-for="question in questions">
                  <home-question :FirstName="question.FirstName" :LastName="question.LastName" :company="question.Name"
                    :Posted="question.Posted" :Fname="question.Fname" :Subject="question.Subject" :Tid="question.Tid"
                    :replies="question.replies" :Fid="question.Fid" />
                </div>
              </div>

              <div v-if="!collabLoading" style="position: absolute; bottom: 0; left: 0; right: 0">
                <a href="/questions" class="link announcement-link">
                  View All
                  <i data-v-5a90ec03 class="material-icons">keyboard_arrow_right</i>
                </a>
              </div>
            </div>
          </div>

          <div class="col col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6">
            <FeaturedVideos />
          </div>
        </div>
      </div>
    </section>
    
    -->
  
    <!-- END -->
     <!--
        <section style="margin-top: 40px">
      <div class="container">
        <div class="">
          <div class="row row-eq-height">
            <div class="col col-6 col-xs-12 col-sm-6 col-md-6 col-lg-3">
              <div class="card feature-card mb20">
                <a @click="showHelp" class="gray-bg tc">
                  <img class="card-img-top" src="@/assets/img/learn.svg" alt />
                </a>
                <div class="card-body">
                  <h5 class="card-title my-2" style="max-height: 30px; overflow: hidden">
                    Learn Spacenet
                  </h5>
                  <p class="small card-text" style="min-height: 38px">
                    This link will enable the Spacenet 3 training tour.
                  </p>
                  <span class="link" @click="showHelp">
                    GO
                    <img style="
                        width: 25px !important;
                        height: 25px !important;
                        max-width: 25px !important;
                        padding: 0;
                      " src="@/assets/img/arrow-right-s-line.svg" />
                  </span>
                </div>
              </div>
            </div>

            <div v-if="this.$store.getters.isExpeditedOrders" class="col col-6 col-xs-12 col-sm-6 col-md-6 col-lg-3">
              <div class="card feature-card mb20">
                <a href="/expedited-orders" class="orange-bg tc">
                  <img class="card-img-top" src="@/assets/img/locker-orders.svg" alt />
                </a>
                <div class="card-body">
                  <h5 class="card-title my-2" style="max-height: 30px; overflow: hidden">
                    <span v-if="this.$store.state.expeditedOrderCount !== null" class="badge badge-orange"
                      style="margin-right: 5px; font-size: inherit">{{ this.$store.state.expeditedOrderCount }}</span>
                    Expedited Orders
                  </h5>
                  <p class="small card-text" style="min-height: 38px">
                    Order status related to Spacesaver parts requests.
                  </p>
                  <a class="link" href="/expedited-orders" style="text-decoration: none; color: #575757;">
                    GO
                    <img style="
                        width: 25px !important;
                        height: 25px !important;
                        max-width: 25px !important;
                        padding: 0;
                      " src="@/assets/img/arrow-right-s-line.svg" />
                  </a>
                </div>
              </div>
            </div>

            <div v-else-if="
              !this.$store.getters.isExpeditedOrders &&
              !this.$store.getters.hideOrders
            " class="col col-6 col-xs-12 col-sm-6 col-md-6 col-lg-3">
              <div class="card feature-card mb20">
                <a href="/listings" class="orange-bg tc">
                  <img class="card-img-top" src="@/assets/img/locker-orders.svg" alt />
                </a>
                <div class="card-body">
                  <h5 class="card-title my-2" style="max-height: 30px; overflow: hidden">
                    My Orders
                  </h5>
                  <p class="small card-text" style="min-height: 38px">
                    View My Order Listings
                  </p>
                  <a class="link" href="/listings" style="text-decoration: none; color: #575757;">
                    GO
                    <img style="
                        width: 25px !important;
                        height: 25px !important;
                        max-width: 25px !important;
                        padding: 0;
                      " src="@/assets/img/arrow-right-s-line.svg" />
                  </a>
                </div>
              </div>
            </div>

            <div class="col col-6 col-xs-12 col-sm-6 col-md-6 col-lg-3">
              <div class="card feature-card mb20">
                <a href="/questions" class="blue-bg tc">
                  <img class="card-img-top" src="@/assets/img/social-chat.svg" alt />
                </a>
                <div class="card-body">
                  <h5 class="card-title my-2" style="max-height: 30px; overflow: hidden">
                    <span v-if="
                      this.$store.state.newPostCount !== null &&
                      this.$store.state.newPostCount > 0 &&
                      this.$store.state.collaborateView != true
                    " class="badge badge-orange" style="margin-right: 5px; font-size: inherit">{{
                        this.$store.state.newPostCount }}</span>Questions
                  </h5>
                  <p class="small card-text" style="min-height: 38px">
                    Join in the discussion with the Spacesaver group!
                  </p>
                  <a class="link" href="/questions" style="text-decoration: none; color: #575757;">
                    GO
                    <img style="
                        width: 25px !important;
                        height: 25px !important;
                        max-width: 25px !important;
                        padding: 0;
                      " src="@/assets/img/arrow-right-s-line.svg" />
                  </a>
                </div>
              </div>
            </div>

            <div class="col col-6 col-xs-12 col-sm-6 col-md-6 col-lg-3">
              <div class="card feature-card mb20">
                <a href="/marketing-materials" class="teal-bg tc">
                  <img class="card-img-top" src="@/assets/img/marketing-materials.svg" alt />
                </a>
                <div class="card-body">
                  <h5 class="card-title my-2" style="max-height: 30px; overflow: hidden">
                    Marketing Materials
                  </h5>
                  <p class="small card-text" style="min-height: 38px">
                    View product images, documents, and videos.
                  </p>
                  <a class="link" href="/marketing-materials" style="text-decoration: none; color: #575757;">
                    GO
                    <img style="
                        width: 25px !important;
                        height: 25px !important;
                        max-width: 25px !important;
                        padding: 0;
                      " src="@/assets/img/arrow-right-s-line.svg" />
                  </a>
                </div>
              </div>
            </div>

            <div v-if="this.$store.getters.hideOrders" class="col col-6 col-xs-6 col-sm-6 col-md-6 col-lg-3">
              <div class="card feature-card">
                <a href="/calendar" class="orange-bg tc">
                  <img class="card-img-top" src="@/assets/img/calendar.svg" alt />
                </a>
                <div class="card-body">
                  <h5 class="card-title my-2" style="max-height: 30px; overflow: hidden">
                    Spacesaver Events
                  </h5>
                  <p class="small card-text" style="min-height: 38px">
                    Bringing the Spacesaver group together to connect and
                    collaborate!
                  </p>
                  <a class="link" href="/calendar">
                    GO
                    <img style="
                        width: 25px !important;
                        height: 25px !important;
                        max-width: 25px !important;
                        padding: 0;
                      " src="@/assets/img/arrow-right-s-line.svg" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
     -->
    <section class="quick-links">
  <div class="container">
    <div class="row">
      <div v-for="card in quickLinks" :key="card.title" class="col-12 col-sm-6 col-lg-3 ql-col">
        <article class="ql-card">
          <div class="ql-banner" :class="card.color">
            <img :src="card.icon" alt="" class="ql-icon" />
          </div>

          <div class="ql-body">
            <h3 class="ql-title">
              <!-- Action card (opens the tour) -->
              <button v-if="card.action" type="button" class="ql-link" @click="card.action">
                {{ card.title }}
              </button>
              <!-- Page card -->
              <router-link v-else :to="card.to" class="ql-link">
                {{ card.title }}
              </router-link>

              <span v-if="card.badge" class="ql-badge" :aria-label="`${card.badge} new`">
                {{ card.badge }}
              </span>
            </h3>
            <p class="ql-text">{{ truncateShortExcerpt(card.text) }}</p>
            <span class="ql-more" aria-hidden="true">
              {{ card.action ? "Start" : "Go" }} <span class="material-icons">arrow_forward</span>
            </span>
          </div>
        </article>
      </div>
    </div>
  </div>
</section>


    <section id="v-step-8" class="py-5 second-banner fromthefortbg2 fort">
  <img class="bottom-angle" src="@/assets/img/bottom-angle2.svg" alt="" aria-hidden="true" />

  <div class="container">
    <div class="fort-head">
      <div>
        <h2 class="mb-0" data-config-id="header">From The Fort</h2>
        <p class="fort-sub">Monthly insights for the Spacesaver Group</p>
      </div>
      <router-link v-if="!fortLoading && fortPosts.length" to="/from-the-fort" class="fort-all">
        View all issues <span class="material-icons">arrow_forward</span>
      </router-link>
    </div>

    <!-- Loading skeleton -->
    <div v-if="fortLoading" class="row" aria-busy="true">
      <div v-for="n in 3" :key="n" class="col-12 col-sm-6 col-lg-4 fort-col">
        <div class="fort-card fort-card--skeleton">
          <div class="fort-banner skeleton"></div>
          <div class="fort-body">
            <div class="skeleton skeleton-line"></div>
            <div class="skeleton skeleton-line"></div>
            <div class="skeleton skeleton-line short"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty -->
    <div v-else-if="!fortPosts.length" class="fort-empty">
      <span class="material-icons">article</span>
      <p class="mb0">New issues are on the way. Check back soon.</p>
    </div>

    <!-- Cards -->
    <div v-else class="row">
      <div
        v-for="(post, i) in fortPosts"
        :key="post.slug"
        class="col-12 col-sm-6 col-lg-4 fort-col"
        :class="{ 'third-fort-card': i === 2 }"
      >
        <article class="fort-card">
          <div class="fort-banner" :class="bannerColors[i % bannerColors.length]">
            <img src="@/assets/img/fort-icon.png" alt="" class="fort-icon" />
            <span v-if="post.date" class="fort-date">{{ $moment(post.date).format("MMMM YYYY") }}</span>
          </div>

          <div class="fort-body">
            <h3 class="fort-title">
              <router-link :to="`/from-the-fort/${post.slug}`" class="ql-link">
                <span v-html="truncateTitle(post.title)"></span>
              </router-link>
            </h3>
            <p class="fort-excerpt" v-html="truncateExcerpt(post.excerpt)"></p>
            <span class="fort-more" aria-hidden="true">
              Read more <span class="material-icons">arrow_forward</span>
            </span>
          </div>
        </article>
      </div>
    </div>
  </div>

  <img class="faq-top-angle" src="@/assets/img/faq-top2.svg" alt="" aria-hidden="true" />
</section>

    <!-- From The Fort -->
     <!--
        <section id="v-step-8" class="py-5 second-banner fromthefortbg2 fort">
      <img class="bottom-angle" src="@/assets/img/bottom-angle2.svg" />
      <div class="container">
   
        <h2 id="v-step-9" class="mb-0" data-config-id="header">
          From The Fort
        </h2>
        <h5 class="mb-3" style="color: #575757">
          Monthly Insights for the Spacesaver Group
        </h5>
        <div v-if="fortLoading == true || !fromTheFortPosts.length" class="col-xs-12 col-sm-12 col-12 col-lg-12" style="
            min-height: 302px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 3rem !important;
          ">
          <div class="flex-box-wrap">
            <div class="flex-internal">
              <atom-spinner :animation-duration="1000" :size="40" :color="'#575757'" />
              <p style="color: #575757">Loading......</p>
            </div>
          </div>
        </div>

        <div v-else class="row row-eq-height">
          <div class="col-12 col-sm-12 col-md-12">
            <div class="row row-eq-height">
              <div class="col col-6 col-xs-12 col-sm-6 col-md-6 col-lg-4">
                <div class="card fortcard">
           
                  <div class="fortcardimage blue-bg">
                    <div class="fortimagewrap">
                      <img src="@/assets/img/fort-icon.png" />
                    </div>
                  </div>
                  <div class="card-content">
                    <h4 v-html="truncateTitle(fromTheFortPosts[0].title)"></h4>
                    <p v-html="truncateExcerpt(fromTheFortPosts[0].excerpt)
                      " class="small card-text" style="margin-bottom: 15px; min-height: 60px"></p>
                    <a class="link" :href="'/from-the-fort/' + fromTheFortPosts[0].slug"
                      style="text-decoration: none; color: #575757;">
                      Read More
                      <img style="
                          width: 25px !important;
                          height: 25px !important;
                          max-width: 25px !important;
                          
                          padding: 0;
                        " src="@/assets/img/arrow-right-s-line.svg" />
                    </a>
                  </div>
                </div>
              </div>
              <div class="col col-6 col-xs-12 col-sm-6 col-md-6 col-lg-4">
                <div class="card fortcard">
        
                  <div class="fortcardimage teal-bg">
                    <div class="fortimagewrap">
                      <img src="@/assets/img/fort-icon.png" />
                    </div>
                  </div>
                  <div class="card-content">
                    <h4 class v-html="truncateTitle(fromTheFortPosts[1].title)"></h4>
                    <p v-html="truncateExcerpt(fromTheFortPosts[1].excerpt)
                      " class="small card-text" style="margin-bottom: 15px; min-height: 60px"></p>
                    <a class="link" :href="'/from-the-fort/' + fromTheFortPosts[1].slug"
                      style="text-decoration: none; color: #575757;">
                      Read More
                      <img style="
                          width: 25px !important;
                          height: 25px !important;
                          max-width: 25px !important;
                          padding: 0;
                        " src="@/assets/img/arrow-right-s-line.svg" />
                    </a>
                  </div>
                </div>
              </div>

              <div class="col col-6 col-xs-12 col-sm-6 col-md-6 col-lg-4 third-fort-card">
                <div class="card fortcard">
                  <div class="fortcardimage gray-bg">
                    <div class="fortimagewrap">
                      <img src="@/assets/img/fort-icon.png" />
                    </div>
                  </div>
                  <div class="card-content">
                    <h4 class v-html="truncateTitle(fromTheFortPosts[2].title)"></h4>
                    <p v-html="truncateExcerpt(fromTheFortPosts[2].excerpt)
                      " class="small card-text" style="margin-bottom: 15px; min-height: 60px"></p>
                    <a class="link" :href="'/from-the-fort/' + fromTheFortPosts[2].slug"
                      style="text-decoration: none; color: #575757;">
                      Read More
                      <img style="
                          width: 25px !important;
                          height: 25px !important;
                          max-width: 25px !important;
                          padding: 0;
                        " src="@/assets/img/arrow-right-s-line.svg" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img class="faq-top-angle" src="@/assets/img/faq-top2.svg" />
    </section>
    
     -->



    <!--
        <section id="v-step-9" class="py-5 faq-tease">
      <div class="container">
        <h2 id="v-step-9" class="mb-3" data-config-id="header">
          Frequently Asked Questions
        </h2>
        <div v-if="faqLoading == true || !faqPosts.length" class="col-xs-12 col-sm-12 col-12 col-lg-12" style="
            min-height: 302px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;
          ">
          <div class="flex-box-wrap">
            <div class="flex-internal">
              <atom-spinner :animation-duration="1000" :size="40" :color="'#333'" />
              <p style="color: #333">Loading......</p>
            </div>
          </div>
        </div>
        <div v-else class="accordion" id="faq-01">
  <div 
    v-for="(faq, index) in faqPosts" 
    :key="index" 
    class="mb-2 border-bottom bgwhite bs-shadow"
  >

    <h5>
      <button 
        class="btn btn-link btn-block text-left d-flex w-100"
        :class="{ collapsed: openIndex !== index }"
        type="button"
        @click="toggleAccordion(index)"
        style="white-space: normal !important; word-wrap: break-word"
      >
        <span v-html="faq.title"></span>
        
        <i 
          class="p-1 ml-auto my-auto fa fa-arrow-circle-down transition"
          :style="{ 
            width: '30px', 
            height: '30px', 
            color: '#c3cace',
            transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0deg)'
          }"
        ></i>
      </button>
    </h5>


    <div 
      class="collapse answer" 
      :class="{ show: openIndex === index }"
      style="padding: 0 10px"
    >
      <p id="answer" v-html="faq.body"></p>
    </div>
  </div>
</div>
        <div v-if="!faqLoading || faqPosts.length" class="text-center mt20">
          <router-link to="/faq" class="mb0 lh1 mlauto list-btn">See All</router-link>
        </div>
      </div>
    </section>
    
    -->

    <section id="v-step-9" class="py-5 faq-tease">
  <div class="container">
    <div class="faq-head">
      <h2 class="mb0" data-config-id="header">Frequently Asked Questions</h2>
      <router-link v-if="!faqLoading && faqPosts.length" to="/faq" class="faq-all">
        See all FAQs <span class="material-icons">arrow_forward</span>
      </router-link>
    </div>

    <!-- Loading skeleton -->
    <div v-if="faqLoading" class="faq-list" aria-busy="true">
      <div v-for="n in 4" :key="n" class="faq-item faq-skeleton">
        <div class="skeleton-line"></div>
      </div>
    </div>

    <!-- Empty -->
    <div v-else-if="!faqPosts.length" class="faq-empty">
      <span class="material-icons">help_outline</span>
      <p class="mb0">No FAQs yet. Have a question?
        <router-link to="/collaborate">Ask the team</router-link>
      </p>
    </div>

    <!-- Accordion -->
    <div v-else class="faq-list" data-config-id="faq">
      <div
        v-for="(faq, index) in faqPosts"
        :key="faq.id || index"
        class="faq-item"
        :class="{ 'faq-item--open': openIndex === index }"
      >
        <h3 class="faq-q-wrap">
          <button
            :id="`faq-q-${index}`"
            type="button"
            class="faq-q"
            :aria-expanded="openIndex === index"
            :aria-controls="`faq-a-${index}`"
            @click="toggleAccordion(index)"
          >
            <span class="faq-q-text" v-html="faq.title"></span>
            <span class="material-icons faq-chevron" aria-hidden="true">expand_more</span>
          </button>
        </h3>

        <div
          :id="`faq-a-${index}`"
          class="faq-a"
          role="region"
          :aria-labelledby="`faq-q-${index}`"
        >
          <div class="faq-a-inner">
            <div class="faq-a-body" v-html="faq.body"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
import { FingerprintSpinner } from 'epic-spinners'

import HomeTour from "../components/Tours/HomeTour.vue";
import HomeTourNoOrders from "../components/Tours/HomeTourNoOrders.vue";
import HomeQuestion from "../components/HomeQuestionNew.vue";
import HomeReports from "../components/Organisms/HomeReports.vue";
import FeaturedVideos from "../components/video/FeaturedVideosNew.vue";
import Carousel from "../components/carousel/Carousel.vue";
import CarouselSlide from "../components/carousel/CarouselSlide.vue";
import HomeInstalls from "../components/Organisms/HomeInstallsNew.vue";

import NewCarousel from "../components/carousel/NewCarouselNew.vue";
import HomePodcast from "@/components/Organisms/HomePodcast.vue";

import SliderV3 from '../components/carousel/SliderV3.vue';
import FreespanLeaderBoard from "@/components/Organisms/FreespanLeaderBoardOptionMultiDarkNew.vue";
import learnIcon from "@/assets/img/learn.svg";
import ordersIcon from "@/assets/img/locker-orders.svg";
import chatIcon from "@/assets/img/social-chat.svg";
import marketingIcon from "@/assets/img/marketing-materials.svg";
import calendarIcon from "@/assets/img/calendar.svg";


const auth = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("USER"),
  },
};

export default {
  name: "Home",
  components: {
    AtomSpinner,
    FingerprintSpinner,
    HomeTour,
    HomeTourNoOrders,
    HomeQuestion,
    HomeReports,
    FeaturedVideos,
    Carousel: Carousel,
    CarouselSlide: CarouselSlide,
    HomeInstalls,
    NewCarousel,
    SliderV3,
    HomePodcast,
    FreespanLeaderBoard
  },
  data() {
    return {
      server: import.meta.env.VITE_APP_SERVER_URL,
      fromthefort: import.meta.env.VITE_APP_FROM_THE_FORT,
      ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
      media: [],
      acs: [],
      alertLoading: false,
      newsLoading: true,
      fortLoading: false,
      faqLoading: false,
      collabLoading: false,
      reportLoading: false,
      loading: false,
      fromTheFortPosts: [],
      newsPosts: [],
      questions: [],
      faqPosts: [],
      searchValue: "",
      freespanData: null,
      homeAlerts: null,
      listings: null,
      acks: null,
      invs: null,
      openIndex: null,
      homeReports: null,
      bannerColors: ["blue-bg", "teal-bg", "gray-bg"],
      options: {
        infinite: true,
        slidesToShow: 1,
        navButtons: false,
        dots: false,
      },
      sliderLoadingData: [
        {
          id: 0,
          documentId: 0,
          title: "loading",
          ExternalLink: null,
          ShowInBanner: true,
          loading: true,
          SliderImage: {
            documentId: 0,
            id: 0,
            url: "/img/banner-loading.jpg",
            alternativeText: "",
          }
        },
      ]
    };
  },
  methods: {
    firstLoad: function () {
      const token = localStorage.getItem("SSCUSER");

      if (!token) {
        console.warn("JWT token not available yet.");
        return;
      }

      const CREDENTIALS = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      this.$store.commit("setActivePage", "home");
      let windowWidth = window.innerWidth;
      if (Number(windowWidth) < 992) {
        //console.log("mobile");
        this.$store.commit("hideTour");
      }

      //Sentry.setUser({ email: this.$store.state.user.Email });

      if (this.$store.getters.isReports) {
        this.homeReportSync(CREDENTIALS);
      }

      this.newsSync(CREDENTIALS);

      if (this.$store.getters.isACKSnINVS && !this.$store.getters.hideOrders) {
        this.HomeAlertSync(CREDENTIALS);
      }
      if (this.$store.getters.isACKSnINVS && !this.$store.getters.hideOrders) {
        this.$store.commit("SET_EO_COUNT");
      }
      this.freespanDataCall(CREDENTIALS);
      this.collaborateHomeSync(CREDENTIALS);
      if(this.$store.getters.isSpacesaverEmployee){
        this.gapOrderCount(CREDENTIALS);
      }
    },
    toggleAccordion(index) {
      this.openIndex = this.openIndex === index ? null : index
    },

    freespanDataCall: function (auth) {
      return axios
        .get(`${this.server}/api/v1/freespan`, auth)
        .then((response) => {
          const data = response.data;
          this.freespanData = data;
        });
    },

    acSync: function () {
      return axios
        .get(`${this.ordermanageapi}/aclist?active=true`, auth)
        .then((response) => {
          const data = response.data;
          const alph = data.sort((a, b) => (a.acName > b.acName ? 1 : -1));
          this.acs = alph;
          this.$store.commit("UPDATE_ACLIST", this.acs);
        });
    },

    truncateTitle: function (value) {
      if (value.length > 35) {
        value = value.substring(0, 55) + "...";
      }
      return value;
    },

    truncateExcerpt: function (value) {
      if (value.length > 90) {
        value = value.substring(0, 50) + "...";
      }
      return value;
    },
    truncateShortExcerpt: function (value) {
     
      value = value.substring(0, 33) + "...";

      return value;
    },

    gapOrderCount(CREDENTIALS) {

      return axios
        .get(`${this.server}/api/v1/gap-orders`, {
          ...CREDENTIALS,           
          timeout: 15000,          
        })
        .then((response) => {
          if (response.status === 200) {
            const gap_orders = response.data.orders || [];
            const gap_order_length = gap_orders.length;
            console.log("Gap orders fetched:", gap_order_length);
            this.$store.commit("SET_GAP_COUNT", gap_order_length);
          } else if (response.status === 401) {
            this.handleAuthFailure();
          }
        })
        .catch((error) => {
          // Better differentiation of errors
          if (axios.isCancel(error)) {
            console.warn("Gap order request was cancelled");
              return; // Don't logout on cancellation
            }

            if (error.code === "ECONNABORTED" || error.message === "Request aborted") {
              console.warn("Gap order request timed out or aborted");
              // Optional: retry once, or just ignore (don't force logout)
              return;
            }

            if (error.response?.status === 401) {
              this.handleAuthFailure();
              return;
            }

            // For other real errors (network, 500, etc.)
            console.error("Failed to fetch gap orders:", error.message);
            // Only logout on clear auth failures, not on transient network issues
            // this.handleAuthFailure();   ← comment this out or make it conditional
          });
    },

    // Add this helper method in the same component
    handleAuthFailure() {
      localStorage.removeItem("SSCUSER");
      this.$router.push("/");
    },


    /*
    gapOrderCount(CREDENTIALS){
        return axios
                  .get(`${this.server}/api/v1/gap-orders`, 
                  CREDENTIALS,
                {
                  timeout: 15000,
                })
                  .then((response) => {
                      if (response.status === 401) {
                          this.$router.push("/");
                      } else {
                          const gap_orders = response.data.orders
                          const gap_order_length = gap_orders?.length
                          console.log("gap " + gap_orders)
                          this.$store.commit("SET_GAP_COUNT", gap_order_length);
                      }
                  })
                  .catch((error) => {
                      localStorage.removeItem("SSCUSER");
                      this.$router.push("/");
                  });
    },
    */



    newsSync() {
      this.newsLoading = true;
      this.newsPosts = this.newsPosts || []; // Initialize as array if undefined

      const storedPosts = localStorage.getItem('announcementHomePosts');

      if (storedPosts?.length) {
        try {
          this.newsPosts = JSON.parse(storedPosts); // Parse JSON string
          this.$store.commit("UPDATE_ANNOUNCEMENTS_HOME", this.newsPosts);
          this.newsLoading = false;
        } catch (e) {
          console.error('Failed to parse storedPosts:', e);
          this.newsLoading = false;
        }
      } else {
        if (this.$store.state.announcements.announcementHomePosts.length) {
          this.newsPosts = this.$store.state.announcements.announcementHomePosts;
          this.newsLoading = false;
        } else {
          fetch(`https://news.spacesaver.com/api/news-feeds?sort[0]=publishedAt:desc&pagination[limit]=20&populate=*`)
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then(data => {
              this.newsPosts = data.data || [];
              this.$store.commit("UPDATE_ANNOUNCEMENTS_HOME", this.newsPosts);
              this.newsLoading = false;
            })
            .catch(error => {
              console.error('Fetch error:', error);
              this.newsPosts = [];
              this.newsLoading = false;
            });
        }
      }
    },

    HomeAlertSync(CREDENTIALS) {
      if (this.$store.state.homeNotifications) {
        this.homeAlerts = this.$store.state.homeNotifications;

        // Fetch new data and update homeAlerts after displaying previous data
        axios
          .get(`${this.ordermanageapi}/homenotifications`, CREDENTIALS)
          .then((response) => {
            this.homeAlerts = response.data;
            this.$store.commit("UPDATE_HOME_NOTIFICATIONS", this.homeAlerts);
          })
          .catch((error) => {
            // console.error("Error fetching home notifications:", error);
          });
      } else {
        this.alertLoading = true;

        axios
          .get(`${this.ordermanageapi}/homenotifications`, CREDENTIALS)
          .then((response) => {
            this.homeAlerts = response.data;
            this.alertLoading = false;
            this.$store.commit("UPDATE_HOME_NOTIFICATIONS", this.homeAlerts);
          })
          .catch((error) => {
            if (error.request.status === 401) {
              this.$router.push("/");
            }
            // console.error("Error fetching home notifications:", error);
            this.alertLoading = false;
          });
      }
    },

    collaborateHomeSync(CREDENTIALS) {
      if (!this.$store.state.collaborate.questionsHome.length) {
        this.collabLoading = true;

        return axios
          .get(
            `${import.meta.env.VITE_APP_SERVER_URL}/api/v1/questions-home`,
            CREDENTIALS
          )
          .then((response) => {
            // console.log(response)
            this.questions = response.data;
            this.collabLoading = false;
            this.$store.commit("UPDATE_COLLABORATE_HOME", this.questions);
          })
          .catch((error) => {
            console.log(error);
            if (error.request.status === 401) {
              this.$router.push("/");
            }
            // console.error("Error fetching questions:", error);
            this.collabLoading = false;
          });
      } else {
        // Set questions directly from the store if already available
        this.questions = this.$store.state.collaborate.questionsHome.slice(
          0,
          10
        );
        this.collabLoading = false;
      }
    },

    homeReportSync(CREDENTIALS) {
      if (!this.$store.state.reportsHomePosts) {
        this.reportLoading = true;
        // console.log("home reports " + JSON.stringify(auth));

        axios
          .get(`${this.ordermanageapi}/homeReports`, CREDENTIALS)
          .then((response) => {

            // console.log("home reports response " + response)
            // console.log("home reports auth after " + auth);
            this.homeReports = response.data;
            this.reportLoading = false;
            this.$store.commit("UPDATE_REPORTS_HOME", this.homeReports);

          })
          .catch((error) => {
            if (error.request.status === 401) {
              this.$router.push("/");
            }
            console.log("home reports response " + error);
            console.log("home reports auth after " + auth);
            // console.error("Error fetching home reports:", error);
            this.reportLoading = false;
          });
      } else {
        this.homeReports = this.$store.state.reportsHomePosts;
        this.reportLoading = false;
      }
    },

    /*
    newsSync: function () {
      this.newsLoading = true;
      if (this.$store.state.announcements.announcementHomePosts.length) {
        this.newsPosts = this.$store.state.announcements.announcementHomePosts;
        this.newsLoading = false;
      } else {
        return axios
          .get(
            `https://spacenetcontent.spacesaver.com/wp-json/wp/v2/news?per_page=30`
          )
          .then((response) => {
            //console.log(response);
            this.newsPosts = response.data;
            this.newsLoading = false;
            this.$store.commit("UPDATE_ANNOUNCEMENTS_HOME", this.newsPosts);
          });
      }
    },
    */

    /*
     homeReportSync: function () {
      return axios
        .get(`${this.ordermanageapi}/homeReports`, auth)
        .then((response) => {
          this.homeReports = response.data;
          //this.$store.commit("UPDATE_FAQS_HOME", this.faqPosts);
        });
    },
*/
    getAllAcks: function () {
      return axios
        .get(
          `${this.ordermanageapi}/unprinted?ac=${this.$store.state.user.ACId[0]}&type=ack`,
          auth
        )
        .then((response) => {
          this.acks = response.data;
          //console.log("acks " + response.data);
        });
    },

    getAllInvs: function () {
      return axios
        .get(
          `${this.ordermanageapi}/unprinted?ac=${this.$store.state.user.ACId[0]}&type=inv`,
          auth
        )
        .then((response) => {
          this.invs = response.data;
          //console.log("invs " + response.data);
        });
    },

    listingSync: function () {
      if (!this.$store.state.listings.listings.length) {
        //console.log("getting listings");
        return axios
          .get(`${this.ordermanageapi}/order`, auth)
          .then((response) => {
            //fix null estinated dates so sorting will work
            response.data.forEach(function (o) {
              if (o.estimated_Date === null) {
                o.estimated_Date = "";
              }
            });
            this.listings = response.data;
            this.$store.commit("UPDATE_LISTINGS", this.listings);
          });
      } else {
        this.listings = this.$store.state.listings.listings;
      }
    },
    fortSync: function () {
      this.fortLoading = true;
      if (this.$store.state.fromthefort.fromTheFortPosts.length) {
        this.fromTheFortPosts = this.$store.state.fromthefort.fromTheFortPosts;
        this.fortLoading = false;
      } else {
        return axios
          .get("https://news.spacesaver.com/api/from-the-forts?sort=publishedAt:desc")
          .then((response) => {
            //console.log(response);
            this.fromTheFortPosts = response.data.data;
            this.fortLoading = false;
            this.$store.commit(
              "UPDATE_FROM_THE_FORT_HOME",
              this.fromTheFortPosts
            );
          });
      }
    },
    faqSync: function () {
      this.faqLoading = true;
      if (this.$store.state.faq.faqHomePosts.length) {
        this.faqPosts = this.$store.state.faq.faqHomePosts;
        this.faqLoading = false;
      } else {
        return axios
          .get(
            `https://news.spacesaver.com/api/faqs?sort[0]=publishedAt:desc&pagination[limit]=6`
          )
          .then((response) => {
            //console.log(response);
            this.faqPosts = response.data.data;
            this.faqLoading = false;
            this.$store.commit("UPDATE_FAQS_HOME", this.faqPosts);
          });
      }
    },
    showHelp: function () {
      this.$store.commit("showTour");
      this.$noty.success(
        "The help tour has been enabled, you can disable it by clicking 'Skip tour' or 'Hide Help' in the menu under your name! Help is only available on desktop devices."
      );
    },
    searchOrder: function () {
      this.$router.push({
        path: "/listings",
        query: { search: this.searchValue.trim(), promised: false },
      });
    },
    clearSearch() {
      this.searchValue = "";
    },
  },

  computed: {
    firstName() {
      return this.$store.state.user.FirstName;
    },
    quickLinks() {
  const s = this.$store.state;
  const g = this.$store.getters;
  const cards = [
    {
      title: "Learn SpaceNET",
      text: "Take the SpaceNET 3 training tour.",
      icon: learnIcon,
      color: "gray-bg",
      action: this.showHelp,
    },
  ];

  if (g.isExpeditedOrders) {
    cards.push({
      title: "Expedited Orders",
      text: "Order status for Spacesaver parts requests.",
      icon: ordersIcon,
      color: "orange-bg",
      to: "/expedited-orders",
      badge: s.expeditedOrderCount || null,
    });
  } else if (!g.hideOrders) {
    cards.push({
      title: "My Orders",
      text: "View your order listings.",
      icon: ordersIcon,
      color: "orange-bg",
      to: "/listings",
    });
  }

  cards.push(
    {
      title: "Questions",
      text: "Join the discussion with the Spacesaver group.",
      icon: chatIcon,
      color: "blue-bg",
      to: "/questions",
      badge: s.newPostCount > 0 && !s.collaborateView ? s.newPostCount : null,
    },
    {
      title: "Marketing Materials",
      text: "Product images, documents and videos.",
      icon: marketingIcon,
      color: "teal-bg",
      to: "/marketing-materials",
    }
  );

  if (g.hideOrders) {
    cards.push({
      title: "Spacesaver Events",
      text: "Connect and collaborate with the Spacesaver group.",
      icon: calendarIcon,
      color: "orange-bg",
      to: "/calendar",
    });
  }

  return cards;
},

    fortPosts() {
  return (this.fromTheFortPosts || []).slice(0, 3);
},
    calcNewsPosts: function () {

      if (!this.newsLoading && this.newsPosts) {
        let filteredNews = this.newsPosts.filter(function (el) {
          return !el.ExcludeFromFeed;
        });
        // return filteredNews;
        return filteredNews.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      } else {
        return []
      }
    },

    calcBanners: function () {

      if (!this.newsLoading && this.newsPosts) {
        let filteredBanners = this.newsPosts.filter(function (el) {
          return el.ShowInBanner;
        });
        return filteredBanners;
      } else {
        return []
      }
    },
  },

  // after creating the component
  created() {
    this.fortSync();
    this.faqSync();
  },

  // before creting the component
  mounted() {
    this.$store.commit("showNavigation");
    this.firstLoad();
    
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.example-slide {
  align-items: center;
  background-color: #666;
  color: #999;
  display: flex;
  font-size: 1.5rem;
  justify-content: center;
  min-height: 10rem;
}

.slider-banner {
  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1600 900'%3E%3ClinearGradient id='a' gradientUnits='objectBoundingBox' x1='0' y1='0' x2='1' y2='1'%3E%3Cstop offset='0' stop-color='%23004033'/%3E%3Cstop offset='0.2' stop-color='%23008066'/%3E%3Cstop offset='0.5' stop-color='%239FF'/%3E%3Cstop offset='0.8' stop-color='%23008066'/%3E%3Cstop offset='1' stop-color='%23004033'/%3E%3C/linearGradient%3E%3ClinearGradient id='b' gradientUnits='objectBoundingBox' x1='1' y1='0' x2='0' y2='1'%3E%3Cstop offset='0' stop-color='%2309F'/%3E%3Cstop offset='0.5' stop-color='%230FC'/%3E%3Cstop offset='1' stop-color='%2309F'/%3E%3C/linearGradient%3E%3Crect fill='url(%23a)' width='1600' height='900'/%3E%3Cpolygon fill='%23ffffff' opacity='.5' points='0 0 1670 -1670 1670 1670'/%3E%3Crect fill='url(%23b)' opacity='.5' width='1600' height='900'/%3E%3Cg fill='%23ffffff'%3E%3Cpolygon opacity='.25' points='0 900 1670 -770 1670 2570'/%3E%3Cpolygon opacity='.25' points='450 450 2050 -1150 2050 2050'/%3E%3Cg fill-opacity='.4'%3E%3Cpath d='M700 900 l1650-1650l0 3300Z'/%3E%3Cpath d='M700 0 l1650-1650l0 3300Z'/%3E%3C/g%3E%3Cpath d='M1150 450 l1600-1600l0 3200z'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
  position: relative;
  /*new*/
  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1600 900'%3E%3ClinearGradient id='a' gradientUnits='objectBoundingBox' x1='0' y1='0' x2='1' y2='1'%3E%3Cstop offset='0' stop-color='%23005a5a'/%3E%3Cstop offset='0.2' stop-color='%2300b4b4'/%3E%3Cstop offset='0.5' stop-color='%239FF'/%3E%3Cstop offset='0.8' stop-color='%2300b4b4'/%3E%3Cstop offset='1' stop-color='%23005a5a'/%3E%3C/linearGradient%3E%3ClinearGradient id='b' gradientUnits='objectBoundingBox' x1='1' y1='0' x2='0' y2='1'%3E%3Cstop offset='0' stop-color='%2300b4b4'/%3E%3Cstop offset='0.5' stop-color='%230FC'/%3E%3Cstop offset='1' stop-color='%2300b4b4'/%3E%3C/linearGradient%3E%3Crect fill='url(%23a)' width='1600' height='900'/%3E%3Cpolygon fill='%23ffffff' opacity='.5' points='0 0 1670 -1670 1670 1670'/%3E%3Crect fill='url(%23b)' opacity='.5' width='1600' height='900'/%3E%3Cg fill='%23ffffff'%3E%3Cpolygon opacity='.25' points='0 900 1670 -770 1670 2570'/%3E%3Cpolygon opacity='.25' points='450 450 2050 -1150 2050 2050'/%3E%3Cg fill-opacity='.4'%3E%3Cpath d='M700 900 l1650-1650l0 3300Z'/%3E%3Cpath d='M700 0 l1650-1650l0 3300Z'/%3E%3C/g%3E%3Cpath d='M1150 450 l1600-1600l0 3200z'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
  /*newer*/
  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1600 900'%3E%3ClinearGradient id='a' gradientUnits='objectBoundingBox' x1='0' y1='0' x2='1' y2='1'%3E%3Cstop offset='0' stop-color='%23363e45'/%3E%3Cstop offset='0.2' stop-color='%236b7c8a'/%3E%3Cstop offset='0.5' stop-color='%236b7c8a'/%3E%3Cstop offset='0.8' stop-color='%236b7c8a'/%3E%3Cstop offset='1' stop-color='%23363e45'/%3E%3C/linearGradient%3E%3ClinearGradient id='b' gradientUnits='objectBoundingBox' x1='1' y1='0' x2='0' y2='1'%3E%3Cstop offset='0' stop-color='%236b7c8a'/%3E%3Cstop offset='0.5' stop-color='%236b7c8a'/%3E%3Cstop offset='1' stop-color='%236b7c8a'/%3E%3C/linearGradient%3E%3Crect fill='url(%23a)' width='1600' height='900'/%3E%3Cpolygon fill='%23ffffff' opacity='.5' points='0 0 1670 -1670 1670 1670'/%3E%3Crect fill='url(%23b)' opacity='.5' width='1600' height='900'/%3E%3Cg fill='%23ffffff'%3E%3Cpolygon opacity='.25' points='0 900 1670 -770 1670 2570'/%3E%3Cpolygon opacity='.25' points='450 450 2050 -1150 2050 2050'/%3E%3Cg fill-opacity='.4'%3E%3Cpath d='M700 900 l1650-1650l0 3300Z'/%3E%3Cpath d='M700 0 l1650-1650l0 3300Z'/%3E%3C/g%3E%3Cpath d='M1150 450 l1600-1600l0 3200z'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}

/*
.carousel-item {
  border: 2px solid #fff;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}
*/
.carousel {
  border: 2px solid #fff;
  border-radius: 0.25rem !important;
  overflow: hidden;
}

.carousel-item img {
  width: 100%;
}

/*
.controls {
  font-size: 2em;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.45);
}
*/
.second-banner {
  background-color: #f1f6f9;

  padding-top: 25px;
  /*
  padding-bottom: 30px;
  */
}

.welcome-text {
  padding: 5px;
  color: #fff;
  background: rgba(0, 0, 0, 0.2);
}

.bgwhite {
  background: #fff;
}

.faq-heading {
  margin-bottom: 0 !important;
}

.collapse {
  padding: 0px 10px !important;
}

.collapse.show {
  padding: 0px 10px !important;
}

.faq-01 .btn {
  text-decoration: none !important;
}

.faq-01 .btn:hover {
  text-decoration: none !important;
}

.btn-link {
  color: #333;
}

.btn-link i {
  color: rgba(92, 109, 126, 0.9);
}

.btn-link:hover {
  color: #000;
  text-decoration: none !important;
  background-color: transparent;
  border-color: transparent;
}

.btn-link:focus {
  color: #000;
  text-decoration: none !important;
}

.accordion h5 {
  margin-bottom: 0 !important;
  font-weight: bold !important;
  font-size: 1.1em !important;
  line-height: 1.2;
}

.accordion div {
  padding: 10px;
}

.see-all-btn {
  background: #00b4b4;
  color: #fff;
}

.fromfortbg {
  background-color: rgba(92, 109, 126, 0.9);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' viewBox='0 0 1600 800'%3E%3Cg fill-opacity='0.2'%3E%3Cg fill='%23262626'%3E%3Cpolygon points='1600 800 1400 800 1600 0'/%3E%3Cpolygon points='800 800 1600 600 1600 800'/%3E%3C/g%3E%3Cg fill='%23262626'%3E%3Cpolygon points='0 0 200 0 0 800'/%3E%3Cpolygon points='800 0 0 200 0 0'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}

.mw300 {
  max-width: 300px;
  margin-bottom: 5px;
}

.fortcardimage {
  width: 100%;
  height: auto;
  min-height: 180px;

  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
}

.fortbg1 {
  background: #2aaae2;
  background-color: #2aaae2;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1600 900'%3E%3Cg fill-opacity='.06'%3E%3Cpath transform='rotate(0 636 600)' d='M1324 485c-81-58-192-40-282-73a722 722 0 0 1-319-252C652 68 562-56 429-39l-5 1a185 185 0 0 0-155 200c5 46 19 91 23 137 10 115-73 172-172 203-61 19-124 37-172 82-57 56-74 143-59 221a573 573 0 0 0 413 419c120 25 247 3 341-74 108-88 221-175 351-229 108-45 264-67 346-159 64-72 67-218-16-277z' fill='%23296e90'/%3E%3Cpath transform='rotate(0 1212 210)' d='M1864 416c-32-58-99-107-112-174-11-58 24-111 58-153 85-104 95-218 3-298s-202-83-261-110c-76-35-125-91-189-141-62-47-139-79-217-53-76 26-124 121-145 193-25 83 18 169-2 252-21 86-92 121-158 168-68 49-144 85-206 142-47 43-134 138-112 208 23 76 93 129 160 164 92 49 201 77 302 52 112-28 243-24 293 73 45 88 112 189 218 201a382 382 0 0 0 409-329c6-67-9-136-41-195z' fill='%231d3747'/%3E%3Cpath transform='rotate(0 420 165)' d='M887-281c-175-247-488-265-666-89C31-181-453 618 24 803c231 90 338-283 709-346 370-63 328-490 154-738z' fill='%23000'/%3E%3C/g%3E%3C/svg%3E");
  background-size: cover;
}

.fortbg2 {
  background: #3f5364;
  background-color: #3f5364;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1600 900'%3E%3Cg fill-opacity='.06'%3E%3Cpath transform='rotate(0 636 600)' d='M1324 485c-81-58-192-40-282-73a722 722 0 0 1-319-252C652 68 562-56 429-39l-5 1a185 185 0 0 0-155 200c5 46 19 91 23 137 10 115-73 172-172 203-61 19-124 37-172 82-57 56-74 143-59 221a573 573 0 0 0 413 419c120 25 247 3 341-74 108-88 221-175 351-229 108-45 264-67 346-159 64-72 67-218-16-277z' fill='%232c3843'/%3E%3Cpath transform='rotate(0 1212 210)' d='M1864 416c-32-58-99-107-112-174-11-58 24-111 58-153 85-104 95-218 3-298s-202-83-261-110c-76-35-125-91-189-141-62-47-139-79-217-53-76 26-124 121-145 193-25 83 18 169-2 252-21 86-92 121-158 168-68 49-144 85-206 142-47 43-134 138-112 208 23 76 93 129 160 164 92 49 201 77 302 52 112-28 243-24 293 73 45 88 112 189 218 201a382 382 0 0 0 409-329c6-67-9-136-41-195z' fill='%231a1f24'/%3E%3Cpath transform='rotate(0 420 165)' d='M887-281c-175-247-488-265-666-89C31-181-453 618 24 803c231 90 338-283 709-346 370-63 328-490 154-738z' fill='%23000'/%3E%3C/g%3E%3C/svg%3E");
  background-size: cover;
}

.fortbg3 {
  background-color: #00b4b4;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1600 900'%3E%3Cg fill-opacity='.06'%3E%3Cpath transform='rotate(0 636 600)' d='M1324 485c-81-58-192-40-282-73a722 722 0 0 1-319-252C652 68 562-56 429-39l-5 1a185 185 0 0 0-155 200c5 46 19 91 23 137 10 115-73 172-172 203-61 19-124 37-172 82-57 56-74 143-59 221a573 573 0 0 0 413 419c120 25 247 3 341-74 108-88 221-175 351-229 108-45 264-67 346-159 64-72 67-218-16-277z' fill='%23282e32'/%3E%3Cpath transform='rotate(0 1212 210)' d='M1864 416c-32-58-99-107-112-174-11-58 24-111 58-153 85-104 95-218 3-298s-202-83-261-110c-76-35-125-91-189-141-62-47-139-79-217-53-76 26-124 121-145 193-25 83 18 169-2 252-21 86-92 121-158 168-68 49-144 85-206 142-47 43-134 138-112 208 23 76 93 129 160 164 92 49 201 77 302 52 112-28 243-24 293 73 45 88 112 189 218 201a382 382 0 0 0 409-329c6-67-9-136-41-195z' fill='%23181a1c'/%3E%3Cpath transform='rotate(0 420 165)' d='M887-281c-175-247-488-265-666-89C31-181-453 618 24 803c231 90 338-283 709-346 370-63 328-490 154-738z' fill='%23000'/%3E%3C/g%3E%3C/svg%3E");
  background-size: cover;
}

.fortbg4 {
  background-color: rgba(92, 109, 126, 1);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1600 900'%3E%3Cg fill-opacity='.06'%3E%3Cpath transform='rotate(0 636 600)' d='M1324 485c-81-58-192-40-282-73a722 722 0 0 1-319-252C652 68 562-56 429-39l-5 1a185 185 0 0 0-155 200c5 46 19 91 23 137 10 115-73 172-172 203-61 19-124 37-172 82-57 56-74 143-59 221a573 573 0 0 0 413 419c120 25 247 3 341-74 108-88 221-175 351-229 108-45 264-67 346-159 64-72 67-218-16-277z' fill='%23282e32'/%3E%3Cpath transform='rotate(0 1212 210)' d='M1864 416c-32-58-99-107-112-174-11-58 24-111 58-153 85-104 95-218 3-298s-202-83-261-110c-76-35-125-91-189-141-62-47-139-79-217-53-76 26-124 121-145 193-25 83 18 169-2 252-21 86-92 121-158 168-68 49-144 85-206 142-47 43-134 138-112 208 23 76 93 129 160 164 92 49 201 77 302 52 112-28 243-24 293 73 45 88 112 189 218 201a382 382 0 0 0 409-329c6-67-9-136-41-195z' fill='%23181a1c'/%3E%3Cpath transform='rotate(0 420 165)' d='M887-281c-175-247-488-265-666-89C31-181-453 618 24 803c231 90 338-283 709-346 370-63 328-490 154-738z' fill='%23000'/%3E%3C/g%3E%3C/svg%3E");
  background-size: cover;
}

.card-content {
  padding: 10px;
}

.fortcard {
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 5%);
  border-radius: 0.25rem !important;
  overflow: hidden;
  margin-bottom: 30px;
}

.fortimagewrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.fortimagewrap img {
  max-width: 100px;
}

.more-link {
  display: inline-block !important;
  justify-content: center;
}

.more-link i {
  font-size: 14px;
}

.post-title {
  font-size: 2.2em;
}

.post-excerpt {
  padding-bottom: 0;
  margin-bottom: 0;
}

.feature-card {
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 5%);
  border-radius: 4px !important;
  overflow: hidden;
  /*height: calc(100% - 30px);*/
  position: relative;
  box-sizing: border-box;
}

.feature-card img {
  /*background: #f7fafc;*/
  max-width: 70%;
  text-align: center;
  padding: 40px;
  -webkit-filter: drop-shadow(3px 3px 2px rgba(134, 134, 134, 0.1));
  filter: drop-shadow(3px 3px 2px rgba(134, 134, 134, 0.1));
}

@media screen and (max-width: 991px) {
  .feature-card img {
    padding: 20px;
  }
}

.orange-bg {
  background: #f16232;
  background-color: #f16232;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1600 900'%3E%3Cg fill-opacity='0.08'%3E%3Cpath transform='rotate(0 636 600)' d='M1324 485c-81-58-192-40-282-73a722 722 0 0 1-319-252C652 68 562-56 429-39l-5 1a185 185 0 0 0-155 200c5 46 19 91 23 137 10 115-73 172-172 203-61 19-124 37-172 82-57 56-74 143-59 221a573 573 0 0 0 413 419c120 25 247 3 341-74 108-88 221-175 351-229 108-45 264-67 346-159 64-72 67-218-16-277z' fill='%239b4324'/%3E%3Cpath transform='rotate(0 1212 210)' d='M1864 416c-32-58-99-107-112-174-11-58 24-111 58-153 85-104 95-218 3-298s-202-83-261-110c-76-35-125-91-189-141-62-47-139-79-217-53-76 26-124 121-145 193-25 83 18 169-2 252-21 86-92 121-158 168-68 49-144 85-206 142-47 43-134 138-112 208 23 76 93 129 160 164 92 49 201 77 302 52 112-28 243-24 293 73 45 88 112 189 218 201a382 382 0 0 0 409-329c6-67-9-136-41-195z' fill='%234d2517'/%3E%3Cpath transform='rotate(0 420 165)' d='M887-281c-175-247-488-265-666-89C31-181-453 618 24 803c231 90 338-283 709-346 370-63 328-490 154-738z' fill='%23000'/%3E%3C/g%3E%3C/svg%3E");
  background-size: cover;
  /*
  background: linear-gradient(to right, #f16232 50%, #c24b23 50%);
*/
  /*
    background: linear-gradient(
    to top,
    rgba(223, 80, 46, 1),
    rgba(223, 80, 46, 0.9)
  );
  background-color: #e05b2f;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' width='100%25' height='200' viewBox='0 0 1600 100'%3E%3Cpath fill='%23c9512a' d='M1600 100 0 0 1600 0Z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: 100% 200px;
  background-position: top center;
  */
}

.blue-bg {
  background: #4d5967;
  border-top-left-radius: 4px !important;
  border-top-right-radius: 4px !important;
  background-color: #4d5967;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1600 900'%3E%3Cg fill-opacity='0.08'%3E%3Cpath transform='rotate(0 636 600)' d='M1324 485c-81-58-192-40-282-73a722 722 0 0 1-319-252C652 68 562-56 429-39l-5 1a185 185 0 0 0-155 200c5 46 19 91 23 137 10 115-73 172-172 203-61 19-124 37-172 82-57 56-74 143-59 221a573 573 0 0 0 413 419c120 25 247 3 341-74 108-88 221-175 351-229 108-45 264-67 346-159 64-72 67-218-16-277z' fill='%23343c45'/%3E%3Cpath transform='rotate(0 1212 210)' d='M1864 416c-32-58-99-107-112-174-11-58 24-111 58-153 85-104 95-218 3-298s-202-83-261-110c-76-35-125-91-189-141-62-47-139-79-217-53-76 26-124 121-145 193-25 83 18 169-2 252-21 86-92 121-158 168-68 49-144 85-206 142-47 43-134 138-112 208 23 76 93 129 160 164 92 49 201 77 302 52 112-28 243-24 293 73 45 88 112 189 218 201a382 382 0 0 0 409-329c6-67-9-136-41-195z' fill='%231d2125'/%3E%3Cpath transform='rotate(0 420 165)' d='M887-281c-175-247-488-265-666-89C31-181-453 618 24 803c231 90 338-283 709-346 370-63 328-490 154-738z' fill='%23000'/%3E%3C/g%3E%3C/svg%3E");
  background-size: cover;
}

.gray-bg {
  background: rgba(92, 109, 126, 0.9);
  border-top-left-radius: 4px !important;
  border-top-right-radius: 4px !important;
  background-color: #6b7c8a;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1600 900'%3E%3Cg fill-opacity='0.08'%3E%3Cpath transform='rotate(0 636 600)' d='M1324 485c-81-58-192-40-282-73a722 722 0 0 1-319-252C652 68 562-56 429-39l-5 1a185 185 0 0 0-155 200c5 46 19 91 23 137 10 115-73 172-172 203-61 19-124 37-172 82-57 56-74 143-59 221a573 573 0 0 0 413 419c120 25 247 3 341-74 108-88 221-175 351-229 108-45 264-67 346-159 64-72 67-218-16-277z' fill='%2347525a'/%3E%3Cpath transform='rotate(0 1212 210)' d='M1864 416c-32-58-99-107-112-174-11-58 24-111 58-153 85-104 95-218 3-298s-202-83-261-110c-76-35-125-91-189-141-62-47-139-79-217-53-76 26-124 121-145 193-25 83 18 169-2 252-21 86-92 121-158 168-68 49-144 85-206 142-47 43-134 138-112 208 23 76 93 129 160 164 92 49 201 77 302 52 112-28 243-24 293 73 45 88 112 189 218 201a382 382 0 0 0 409-329c6-67-9-136-41-195z' fill='%23262b2e'/%3E%3Cpath transform='rotate(0 420 165)' d='M887-281c-175-247-488-265-666-89C31-181-453 618 24 803c231 90 338-283 709-346 370-63 328-490 154-738z' fill='%23000'/%3E%3C/g%3E%3C/svg%3E");
  background-size: cover;

  /*
    background: linear-gradient(
    to top,
    rgba(92, 109, 126, 0.9),
    rgba(92, 109, 126, 0.6)
  );
  background-color: #5c6976;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' width='100%25' height='200' viewBox='0 0 1600 100'%3E%3Cpath fill='%234c5661' d='M1600 100 0 0 1600 0Z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: 100% 200px;
  background-position: top center;
  */
}

.teal-bg {
  background: #00b4b4;
  background-color: #00b4b4;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1600 900'%3E%3Cg fill-opacity='0.08'%3E%3Cpath transform='rotate(0 636 600)' d='M1324 485c-81-58-192-40-282-73a722 722 0 0 1-319-252C652 68 562-56 429-39l-5 1a185 185 0 0 0-155 200c5 46 19 91 23 137 10 115-73 172-172 203-61 19-124 37-172 82-57 56-74 143-59 221a573 573 0 0 0 413 419c120 25 247 3 341-74 108-88 221-175 351-229 108-45 264-67 346-159 64-72 67-218-16-277z' fill='%231c7474'/%3E%3Cpath transform='rotate(0 1212 210)' d='M1864 416c-32-58-99-107-112-174-11-58 24-111 58-153 85-104 95-218 3-298s-202-83-261-110c-76-35-125-91-189-141-62-47-139-79-217-53-76 26-124 121-145 193-25 83 18 169-2 252-21 86-92 121-158 168-68 49-144 85-206 142-47 43-134 138-112 208 23 76 93 129 160 164 92 49 201 77 302 52 112-28 243-24 293 73 45 88 112 189 218 201a382 382 0 0 0 409-329c6-67-9-136-41-195z' fill='%23183a3a'/%3E%3Cpath transform='rotate(0 420 165)' d='M887-281c-175-247-488-265-666-89C31-181-453 618 24 803c231 90 338-283 709-346 370-63 328-490 154-738z' fill='%23000'/%3E%3C/g%3E%3C/svg%3E");
  background-size: cover;

  /*
  background-color: #00b4b4;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none' width='100%25' height='200' viewBox='0 0 1600 100'%3E%3Cpath fill='%2300a1a1' d='M1600 100 0 0 1600 0Z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: 100% 200px;
  background-position: top center;
  */
}

.feature-card .card-body {
  padding: 10px;
  flex: 1 1 100%;
}

.link {
  width: 100%;
  display: flex;
  border: none;
  /* text-align: center!important; */
  justify-content: center;
  background: #f1f2f3;
  color: #575757;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.5s ease;
  border-radius: 4px !important;
  overflow: hidden;
  padding: 5px;
}

.link:hover {
  background: rgba(223, 224, 224, 0.9);
}

.link:active {
  background: rgba(223, 224, 224, 0.9);
}

@media screen and (min-width: 992px) {
  .banner-wrap {
    box-sizing: border-box;
    margin-bottom: 30px;
  }
}

/*.top-angle
@media screen and (max-width: 991px) {
  .banner-wrap {
    background: rgba(255, 255, 255, 0) !important;
    padding: 0 !important;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}
*/
.banner-wrap {
  box-sizing: border-box;
  margin-bottom: 30px;
}

@media screen and (max-width: 991px) {
  .banner-wrap {
    margin-bottom: 10px;
  }
}

.tc {
  text-align: center;
}

.top-angle {
  width: 100%;
  position: absolute;
  bottom: 0;
  margin-bottom: -1px;
}

.faq-top-angle {
  width: 100%;
  position: absolute;
  bottom: 0;
  margin-bottom: -1px;
}

.faq-bottom-angle {
  width: 100%;
  position: relative;
  top: 0;
  /* background: #eef0f1; */
  border: 0;
  margin-top: -79px;
}

.bottom-angle {
  width: 100%;
  position: absolute;
  top: 0;
}

@media screen and (max-width: 575px) {
  .faq-top-angle {
    display: none;
  }

  .faq-bottom-angle {
    display: none;
  }

  .top-angle {
    display: none;
  }

  .bottom-angle {
    display: none;
  }
}

.fort {
  position: relative;
}

.faq-tease {
  background-color: #f1f6f9;
  position: relative;
}

.home-footer-top {
  position: relative;
  background-color: #4d5967;
}

.card-strip-top {
  color: #fff;
  padding: 10px;
}

.card-strip-top h5 {
  margin-bottom: 0;
}

.card-scroll {
  padding: 10px;
  /*height: 100%;*/
  overflow: scroll;
}

.card-deck {
  /*height: 100%;*/
  padding-bottom: 1.5rem !important;
}

.card-deck .card {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.45);
}

.h100 {
  height: 100%;
}

.prev-forts {
  background: #f1f2f3;
  padding: 5px 10px;
  margin-bottom: 5px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.5s ease;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
}

.prev-forts i {
  margin-left: auto;
}

.prev-forts:hover {
  background: rgba(223, 224, 224, 0.9);
}

.prev-forts:active {
  background: rgba(223, 224, 224, 0.9);
}

.prev-forts p {
  margin-bottom: 0;
  line-height: 1;
}

.card-scroll a {
  text-decoration: none;
  color: #575757;
}

.accordion p {
  font-weight: 300;
}

.top-news-item {
  margin-bottom: 5px;
  padding: 5px;
  background: #fff;
  padding: 10px;
  border-radius: 4px;
  line-height: 1.4;

  color: #6c757d;
  font-size: 90%;
  font-weight: 300;
  cursor: pointer;
  transition: background 0.5s ease;
  transition: all 0.2s ease-in-out;
}

.top-news-item:hover {
  /*background: #f1f2f3;*/
  /*background: rgba(223, 224, 224, 0.9);*/
  background: #f9f9f9;
}

.top-news-item:active {
  /*background: #f1f2f3;*/
  /*background: rgba(223, 224, 224, 0.9);*/
  background: #f1f1f1;
}

.announcement-banner {
  display: flex;
  flex-direction: column;
}

.announcement-link {
  margin-top: auto;
  background: #00b4b4;
  color: #fff;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 5%);
}
.announcement-link:hover {
  color: #fff;
  text-decoration: none;
}

.announcement-link:hover {
  background: #429da8;
}

.announcement-link:active {
  background: #429da8;
}

/*
@media screen and (max-width: 991px) {
	.announcement-banner {
		height: 200px;
	}
}
*/
@media screen and (min-width: 992px) {
  .announcement-banner {
    height: 214.32px;
  }
}

@media screen and (min-width: 1200px) {
  .announcement-banner {
    height: 256.02px;
  }
}

.news-scroll {
  overflow: scoll;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.news-scroll a:hover {
  text-decoration: none;
}

.news-scroll a:active {
  text-decoration: none;
}

.badge-orange {
  background-color: #00b4b4;
  background-color: #3e4651;
  background-color: #f16232;
  color: #fff;
  font-size: 0.7em !important;
  font-weight: 500;
}

/*
.faq-tease:after {
  content: url(../assets/img/faq-bottom.svg);
}
*/
@media screen and (max-width: 575px) {
  .news-scroll {
    min-height: 180px;
  }

  .card-title {
    /*min-height: 50px;*/
  }

  #v-step-6 {
    padding-top: 30px !important;
    padding-bottom: 20px !important;
  }

  #v-step-8 {
    padding-top: 30px !important;
    padding-bottom: 0px !important;
  }

  .faq-tease {
    padding-top: 30px !important;
    padding-bottom: 30px !important;
  }
}

@media screen and (min-width: 992px) {
  .orange-bg {
    background-attachment: fixed;
  }

  .teal-bg {
    background-attachment: fixed;
  }

  .gray-bg {
    background-attachment: fixed;
  }

  .blue-bg {
    background-attachment: fixed;
  }

  .fortbg1 {
    background-attachment: fixed;
  }

  .fortbg2 {
    background-attachment: fixed;
  }

  .fortbg3 {
    background-attachment: fixed;
  }

  .fortbg4 {
    background-attachment: fixed;
  }
}

.dashboard-card {
  display: flex;
  flex-direction: row;
}

.dashboard-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.dashboard-card {
  background: rgba(46, 54, 62, 80%);
  transition: background 0.5s ease;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.dashboard-card:hover,
.dashboard-card:active {
  background: rgba(46, 54, 62, 100%);
}

.search-area {
  display: flex;
  margin-bottom: 0px;
}

.search-btns {
  /*display: flex;*/
  margin-top: 10px;
  margin-bottom: 10px;
}

.search-btns button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: #4d5967;
  color: #fff;
  border-radius: 4px;
  padding: 23px 5px;
  cursor: pointer;
  padding-left: 10px;
  padding-right: 10px;
  margin-right: 10px;
}

.search-btns .clear {
  margin-right: 0;
  margin-left: 5px;
  padding-left: 10px;
  padding-right: 10px;
}

.search-btns .search {
  /*margin-left: auto;*/
  margin-right: 0;
  margin-left: auto;
}

.search-btns button span {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #fff;
}

.search-btns button:hover {
  background: #586575;
}

.search-btns button:active {
  background: #586575;
}

.search-btns button:disabled {
  opacity: 0.6;
  cursor: unset !important;
}

.search-btns button:disabled:hover {
  background: #4d5967;
}

.search-btns button:disabled:active {
  background: #4d5967;
}

.new-search-btn1 {
  background: #00b4b4;
  color: #fff;
  border: none;
  transition: background-color 0.5s ease;
  cursor: pointer;
}

.new-search-btn1:hover {
  background: #429da8;
}

.new-search-btn2 {
  background: #33848e;
  color: #fff;
  border: none;
  transition: background-color 0.5s ease;
  cursor: pointer;
}

.new-search-btn2:hover {
  background: #2d767f;
}

.badge {
  padding: 0.4em 0.4em !important;
}

.stamp.stamp-md {
  min-width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
}

.stamp {
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  color: #fff;
  font-weight: 600;
  display: inline-block;
  min-width: 2rem;
  height: 2rem;
  padding: 0 0.25rem;
  line-height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
}

.search-wrap {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
}

.search-wrap:hover {
  /*transform: scale(1.04);*/
  box-shadow: 0 10px 20px -12px rgb(0 0 0 / 8%) !important;
}

.question-header {
  background: #fff;
}

.dashboard-card2 {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.dashboard-card2:hover {
  /*transform: scale(1.04);*/
  box-shadow: 0 10px 20px -12px rgb(0 0 0 / 8%) !important;
}

.dashboard-card2:hover .stamp {
  /*transform: scale(1.04);*/
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 5%);
}

.top-news-item {
  transition: all 0.2s ease-in-out;
}

.top-news-item:hover .date-text {
  color: #00b4b4;
}

.teal {
  color: #00b4b4;
}

.orange {
  color: #f16232;
}

.date-text {
  font-weight: 400;
}

.masked-overflow-collaborate {
  /* scroll bar width, for use in mask calculations */
  --scrollbar-width: 8px;

  /* mask fade distance, for use in mask calculations */
  --mask-height: 35px;

  /* If content exceeds height of container, overflow! */
  overflow-y: auto;

  /* Our height limit */
  height: 639px;

  /* Need to make sure container has bottom space,
  otherwise content at the bottom is always faded out */
  padding-bottom: var(--mask-height);

  /* Keep some space between content and scrollbar */
  /* padding-right: 20px;*/

  /* The CSS mask */

  /* The content mask is a linear gradient from top to bottom */
  --mask-image-content: linear-gradient(to bottom,
      transparent,
      black var(--mask-height),
      black calc(100% - var(--mask-height)),
      transparent);

  /* Here we scale the content gradient to the width of the container 
  minus the scrollbar width. The height is the full container height */
  --mask-size-content: calc(100% - var(--scrollbar-width)) 100%;

  /* The scrollbar mask is a black pixel */
  --mask-image-scrollbar: linear-gradient(black, black);

  /* The width of our black pixel is the width of the scrollbar.
  The height is the full container height */
  --mask-size-scrollbar: var(--scrollbar-width) 100%;

  /* Apply the mask image and mask size variables */
  mask-image: var(--mask-image-content), var(--mask-image-scrollbar);
  mask-size: var(--mask-size-content), var(--mask-size-scrollbar);

  /* Position the content gradient in the top left, and the 
  scroll gradient in the top right */
  mask-position: 0 0, 100% 0;

  /* We don't repeat our mask images */
  mask-repeat: no-repeat, no-repeat;
}

.masked-overflow-news {
  /* scroll bar width, for use in mask calculations */
  --scrollbar-width: 8px;

  /* mask fade distance, for use in mask calculations */
  --mask-height: 20px;

  /* If content exceeds height of container, overflow! */
  overflow-y: auto;

  /* Our height limit */
  height: 256px;

  /* Need to make sure container has bottom space,
  otherwise content at the bottom is always faded out */
  padding-bottom: var(--mask-height);

  /* Keep some space between content and scrollbar */
  /* padding-right: 20px;*/

  /* The CSS mask */

  /* The content mask is a linear gradient from top to bottom */
  --mask-image-content: linear-gradient(to bottom,
      transparent,
      black var(--mask-height),
      black calc(100% - var(--mask-height)),
      transparent);

  /* Here we scale the content gradient to the width of the container 
  minus the scrollbar width. The height is the full container height */
  --mask-size-content: calc(100% - var(--scrollbar-width)) 100%;

  /* The scrollbar mask is a black pixel */
  --mask-image-scrollbar: linear-gradient(black, black);

  /* The width of our black pixel is the width of the scrollbar.
  The height is the full container height */
  --mask-size-scrollbar: var(--scrollbar-width) 100%;

  /* Apply the mask image and mask size variables */
  mask-image: var(--mask-image-content), var(--mask-image-scrollbar);
  mask-size: var(--mask-size-content), var(--mask-size-scrollbar);

  /* Position the content gradient in the top left, and the 
  scroll gradient in the top right */
  mask-position: 0 0, 100% 0;

  /* We don't repeat our mask images */
  mask-repeat: no-repeat, no-repeat;
}

.fromthefortbg2 {
  background-color: #f1f6f9;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1600 900'%3E%3Cg fill-opacity='.1'%3E%3Cpath transform='rotate(0 636 600)' d='M1324 485c-81-58-192-40-282-73a722 722 0 0 1-319-252C652 68 562-56 429-39l-5 1a185 185 0 0 0-155 200c5 46 19 91 23 137 10 115-73 172-172 203-61 19-124 37-172 82-57 56-74 143-59 221a573 573 0 0 0 413 419c120 25 247 3 341-74 108-88 221-175 351-229 108-45 264-67 346-159 64-72 67-218-16-277z' fill='%23dadfe1'/%3E%3Cpath transform='rotate(0 1212 210)' d='M1864 416c-32-58-99-107-112-174-11-58 24-111 58-153 85-104 95-218 3-298s-202-83-261-110c-76-35-125-91-189-141-62-47-139-79-217-53-76 26-124 121-145 193-25 83 18 169-2 252-21 86-92 121-158 168-68 49-144 85-206 142-47 43-134 138-112 208 23 76 93 129 160 164 92 49 201 77 302 52 112-28 243-24 293 73 45 88 112 189 218 201a382 382 0 0 0 409-329c6-67-9-136-41-195z' fill='%23c4c8ca'/%3E%3Cpath transform='rotate(0 420 165)' d='M887-281c-175-247-488-265-666-89C31-181-453 618 24 803c231 90 338-283 709-346 370-63 328-490 154-738z' fill='%23AEB1B3'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}

.fortcardimage::before {
  background-image: linear-gradient(to right,
      rgba(42, 170, 226, 0.8),
      rgba(62, 71, 81, 0.8));
}

@media screen and (max-width: 1199px) {
  .masked-overflow-collaborate {
    height: 579px;
    max-height: 579px;
  }
}

@media screen and (min-width: 1200px) {
  .masked-overflow-collaborate {
    height: 639px;
    max-height: 639px;
  }
}

.spacer {
  min-height: 30px;
}

/* carousel */
.carousel {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 94px;

  /*z-index:10;*/
}

.carousel-slider {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  /*     
        display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden
    */
}

/*
.carousel-slider img {

  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
}
*/
.carousel-slider img {
  display: block;
  /* Prevents gaps caused by inline images */
  width: 100%;
  /* Ensures the image fits the width of the slide */
  height: auto;
  /* Maintains the aspect ratio */
  object-fit: contain;
  /* Ensures the image fits within the container without cropping */
}
#newsList {
    overflow: hidden;
  }

@media screen and (min-width: 424px) {
  .carousel {
    position: relative;
    overflow: hidden;
    width: auto;
    min-height: auto;
  }
}

@media screen and (min-width: 479px) {
  .carousel {
    position: relative;
    overflow: hidden;
    width: auto;
    /*height: 154px;*/
    min-height: auto;
  }
}

@media screen and (min-width: 559px) {
  .carousel {
    position: relative;
    overflow: hidden;
    width: auto;
    /*height: 176px;*/
    min-height: auto;
  }
}

@media screen and (min-width: 669px) {
  .carousel {
    position: relative;
    overflow: hidden;
    width: auto;
    /*height: 180px;*/
    min-height: auto;
  }
}

@media screen and (min-width: 767px) {
  .carousel {
    position: relative;
    overflow: hidden;
    width: auto;
    min-height: 180px;
    min-height: auto;
  }
}

@media screen and (min-width: 991px) {
  .carousel {
    position: relative;
    overflow: hidden;
    width: auto;
    /*height: 214px;*/
    min-height: auto;
  }
}

@media screen and (min-width: 1200px) {
  .carousel {
    position: relative;
    overflow: hidden;
    width: auto;
    /*height: 245px;*/
    min-height: auto;
  }
}


@media screen and (max-width: 991px) {
  #newsFeed {
    min-height: 500px;
    margin-bottom: 20px;
  }

  #newsList {
    height: 272px;
  }
}

/* new styles overwrite up top*/

.carousel {
  position: relative;
  overflow: visible;
  /* Let the content flow naturally */
  width: 100%;
  height: auto;
  /* Adjust height based on content */
}

.carousel-slider img {
  display: block;
  /* Prevents gaps caused by inline images */
  width: 100%;
  /* Ensures the image fits the width of the slide */
  height: auto;
  /* Maintains the aspect ratio */
  object-fit: contain;
  /* Prevents cropping of images */
}

.carousel__viewport {
  display: flex;
  align-items: center;
  /* Center slides vertically if necessary */
}

.carousel__track {
  display: flex;
  flex-wrap: nowrap;
}

.carousel__slide {
  flex: 0 0 auto;
  /* Ensure slides don't shrink or stretch */
  width: 100%;
  /* Match the parent's width */
}

.third-fort-card{
  display: none; 
}

@media (min-width: 992px) {
  .third-fort-card {
    display: block; 
  }
}
@media (max-width: 991px) {
  .new-search-btn2 {
    display: none
  }
}


/* end */

.faq-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 20px;
}
.faq-all {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #429da8;
  font-weight: 500;
  white-space: nowrap;
}
.faq-all .material-icons { font-size: 18px; transition: transform 0.2s; }
.faq-all:hover { text-decoration: none; color: #1e3040; }
.faq-all:hover .material-icons { transform: translateX(3px); }

.faq-list { display: flex; flex-direction: column; gap: 10px; }

.faq-item {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-left: 3px solid transparent;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.faq-item:hover { box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1); }
.faq-item--open { border-left-color: #429da8; }

.faq-q-wrap { margin: 0; font-size: inherit; }
.faq-q {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 16px 18px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  color: #1e3040;
  font-size: 17px;
  font-weight: 500;
  line-height: 1.35;
}
.faq-q:focus-visible { outline: 2px solid #429da8; outline-offset: -2px; border-radius: 6px; }
.faq-q-text { flex: 1; }
.faq-chevron {
  flex-shrink: 0;
  color: #8a96a3;
  transition: transform 0.25s ease, color 0.2s;
}
.faq-item--open .faq-chevron { transform: rotate(180deg); color: #429da8; }

/* Smooth open/close without measuring heights */
.faq-a {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s ease;
  
}
.faq-item--open .faq-a { grid-template-rows: 1fr; }
.faq-a-inner { overflow: hidden; }
.faq-a-body {
  padding: 0 18px 18px;
  color: #575757;
  line-height: 1.6;
}
.faq-a-body :deep(p:last-child) { margin-bottom: 0; }
.faq-a-body :deep(a) { color: #429da8; }
.faq-a-body a {
  color: #00b4b4!important;
}

.faq-skeleton { padding: 20px 18px; }
.skeleton-line {
  height: 14px;
  width: 70%;
  border-radius: 4px;
  background: linear-gradient(90deg, #eceff1 25%, #f6f7f8 50%, #eceff1 75%);
  background-size: 200% 100%;
  animation: faq-shimmer 1.2s infinite;
}
@keyframes faq-shimmer {
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
}

.faq-empty {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 24px;
  background: #fff;
  border-radius: 6px;
  color: #575757;
}
.faq-empty .material-icons { color: #429da8; font-size: 28px; }

@media (max-width: 575px) {
  .faq-head { flex-direction: column; align-items: flex-start; }
  .faq-q { font-size: 16px; padding: 14px; }
  .faq-a-body { padding: 0 14px 14px; }
}

/* new fort posts */
.fort-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 24px;
}
.fort-sub {
  color: #575757;
  font-size: 18px;
  font-weight: 300;
  margin: 4px 0 0;
}
.fort-all {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #429da8;
  font-weight: 500;
  white-space: nowrap;
}
.fort-all .material-icons { font-size: 18px; transition: transform 0.2s; }
.fort-all:hover { color: #1e3040; text-decoration: none; }
.fort-all:hover .material-icons { transform: translateX(3px); }

.fort-col { display: flex; margin-bottom: 24px; }

.fort-card {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.2s ease;
}
.fort-card:not(.fort-card--skeleton):hover {
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.14);
}

.fort-banner {
  position: relative;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fort-icon {
  width: 64px;
  height: auto;
  transition: transform 0.3s ease;
}
.fort-card:hover .fort-icon { transform: scale(1.08); }
.fort-date {
  position: absolute;
  left: 14px;
  bottom: 10px;
  color: #fff;
  font-size: 12px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: rgba(0, 0, 0, 0.25);
  padding: 3px 8px;
  border-radius: 3px;
}

.fort-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 18px 20px 20px;
}
.fort-title {
  font-size: 19px;
  line-height: 1.3;
  margin: 0 0 8px;
}
.fort-link {
  color: #1e3040;
  text-decoration: none;
}
/* The whole card is clickable via the title link */
.fort-link::after {
  content: "";
  position: absolute;
  inset: 0;
}
.fort-link:focus-visible { outline: none; }
.fort-card:focus-within { outline: 2px solid #429da8; outline-offset: 2px; }

.fort-excerpt {
  color: #575757;
  font-size: 15px;
  line-height: 1.5;
  margin-bottom: 16px;
}
.fort-excerpt :deep(p) { margin: 0; }
.fort-more {
  margin-top: auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #429da8;
  font-weight: 500;
}
.fort-more .material-icons { font-size: 18px; transition: transform 0.2s; }
.fort-card:hover .fort-more .material-icons { transform: translateX(4px); }

.fort-empty {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  color: #575757;
  margin-bottom: 3rem;
}
.fort-empty .material-icons { color: #429da8; font-size: 28px; }

.skeleton {
  background: linear-gradient(90deg, #eceff1 25%, #f6f7f8 50%, #eceff1 75%);
  background-size: 200% 100%;
  animation: fort-shimmer 1.2s infinite;
}
.skeleton-line { height: 12px; border-radius: 4px; margin-bottom: 10px; }
.skeleton-line.short { width: 50%; }
@keyframes fort-shimmer {
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
}

@media (max-width: 575px) {
  .fort-head { flex-direction: column; align-items: flex-start; }
}
.fort-link,
.fort-link:hover,
.fort-link:focus {
  color: #1e3040;
  text-decoration: none;
}

/* quick links */
.quick-links {
  margin-top: 40px;
}
.ql-col {
  display: flex;
  margin-bottom: 24px;
}
.ql-card {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.2s ease;
}
.ql-card:hover {
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.14);
}
.ql-banner {
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ql-icon {
  max-height: 80px;
  max-width: 70%;
  transition: transform 0.3s ease;
}
.ql-card:hover .ql-icon {
  transform: scale(1.06);
}
.ql-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 18px 20px 20px;
}
.ql-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 19px;
  line-height: 1.3;
  margin: 0 0 6px;
}
.ql-link,
.ql-link:hover,
.ql-link:focus {
  color: #1e3040;
  text-decoration: none !important;
  font: inherit;
  background: none;
  border: none;
  padding: 0;
  text-align: left;
  cursor: pointer;
}
/* Make the whole card clickable */
.ql-link::after {
  content: "";
  position: absolute;
  inset: 0;
}
.ql-link:focus-visible {
  outline: none;
}
.ql-card:focus-within {
  outline: 2px solid #429da8;
  outline-offset: 2px;
}
.ql-badge {
  background: #f16232;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  padding: 4px 8px;
  border-radius: 999px;
}
.ql-text {
  color: #575757;
  font-size: 15px;
  line-height: 1.5;
  margin-bottom: 16px;
}
.ql-more {
  margin-top: auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #429da8;
  font-weight: 500;
}
.ql-more .material-icons {
  font-size: 18px;
  transition: transform 0.2s;
}
.ql-card:hover .ql-more .material-icons {
  transform: translateX(4px);
}
.ql-banner {
  position: relative; /* add this to your existing .ql-banner rule */
}

.ql-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: #fff;
  color: #1e3040;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  padding: 6px 10px 6px 8px;
  border-radius: 999px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
}
.ql-badge-label {
  font-weight: 400;
  color: #575757;
  font-size: 13px;
}
.ql-badge-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f16232;
  box-shadow: 0 0 0 0 rgba(241, 98, 50, 0.6);
  animation: ql-pulse 2s infinite;
}
@keyframes ql-pulse {
  0%   { box-shadow: 0 0 0 0 rgba(241, 98, 50, 0.6); }
  70%  { box-shadow: 0 0 0 7px rgba(241, 98, 50, 0); }
  100% { box-shadow: 0 0 0 0 rgba(241, 98, 50, 0); }
}
@media (prefers-reduced-motion: reduce) {
  .ql-badge-dot { animation: none; }
}
.fort-card:focus-within {
  outline: none;
}
.fort-card:has(.fort-link:focus-visible) {
  outline: 2px solid #429da8;
  outline-offset: 2px;
}
.fort-link:focus,
.fort-link:active {
  outline: none;
  box-shadow: none;
}
.ql-card:focus-within {
  outline: none;
}
.ql-card:has(.ql-link:focus-visible) {
  outline: 2px solid #429da8;
  outline-offset: 2px;
}
.ql-link:focus,
.ql-link:active {
  outline: none;
  box-shadow: none;
}
.fort-title {
  font-size: 19px !important;
  font-weight: 500 !important;
  line-height: 1.3 !important;
  color: #1e3040 !important;
}

/* Anything the CMS puts inside the title inherits the size */
.fort-title :deep(*) {
  font-size: inherit !important;
  font-weight: inherit !important;
  line-height: inherit !important;
  margin: 0;
}


/* new styles */
.home-split .split-col {
  display: flex;
  margin-bottom: 24px;
}
.home-split .panel {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.home-split .panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 16px 20px;
  border-bottom: 1px solid #eef0f2;
}
.home-split .panel-title {
  font-size: 20px;
  font-weight: 600;
  color: #1e3040;
  margin: 0;
}
.home-split .panel-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #429da8;
  font-weight: 500;
}
.home-split .panel-link:hover { color: #1e3040; text-decoration: none; }
.home-split .panel-link .material-icons { font-size: 18px; }

/* The list fills the panel and scrolls; on desktop it matches the video panel's height */
.home-split .q-list {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
}
@media (max-width: 991px) {
  .home-split .q-list { flex: none; max-height: 520px; }
}

.home-split .panel-empty {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 30px 20px;
  color: #575757;
}
.home-split .panel-empty .material-icons { color: #429da8; font-size: 28px; }

.home-split .q-skeleton {
  display: flex;
  gap: 12px;
  padding: 18px 20px;
  border-bottom: 1px solid #eef0f2;
}
.home-split .sk {
  background: linear-gradient(90deg, #eceff1 25%, #f6f7f8 50%, #eceff1 75%);
  background-size: 200% 100%;
  animation: sk-shimmer 1.2s infinite;
  border-radius: 4px;
}
.home-split .sk-avatar { width: 36px; height: 36px; border-radius: 50%; flex-shrink: 0; }
.home-split .sk-lines { flex: 1; }
.home-split .sk-line { height: 12px; margin: 4px 0 10px; }
.home-split .sk-line.short { width: 55%; }
@keyframes sk-shimmer {
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
}

/* news styles */
.news-row { margin-bottom: 24px; }
.news-col { display: flex; flex-direction: column; margin-bottom: 20px; }

.panel {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 14px 18px;
  border-bottom: 1px solid #eef0f2;
}
.panel-title { font-size: 18px; font-weight: 600; color: #1e3040; margin: 0; }
.panel-link { display: inline-flex; align-items: center; gap: 4px; color: #429da8; font-weight: 500; }
.panel-link:hover { color: #1e3040; text-decoration: none; }
.panel-link .material-icons { font-size: 18px; }
.panel-empty { display: flex; align-items: center; gap: 10px; padding: 24px 18px; color: #575757; }
.panel-empty .material-icons { color: #429da8; font-size: 26px; }

/* On desktop the list matches the banner's height and scrolls inside */
.news-panel { flex: 1; min-height: 0; }
.news-list {
  list-style: none;
  margin: 0;
  padding: 0;
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
}
@media (max-width: 991px) {
  .news-list { flex: none; max-height: 360px; }
}
.news-item + .news-item { border-top: 1px solid #f0f2f4; }
.news-link {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 18px;
  color: #1e3040;
  text-decoration: none !important;
  transition: background 0.15s;
}
.news-link:hover { background: #f7f9fa; }
.news-link:focus-visible { outline: 2px solid #429da8; outline-offset: -2px; }
.news-link time {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #429da8;
}
.news-title {
  color: #1e3040 !important;
  font-size: 15px;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.news-ext { font-size: 14px; color: #a3abb3; vertical-align: -2px; }

.news-item .sk {
  background: linear-gradient(90deg, #eceff1 25%, #f6f7f8 50%, #eceff1 75%);
  background-size: 200% 100%;
  animation: news-shimmer 1.2s infinite;
  border-radius: 4px;
}
.news-item:has(.sk) { padding: 12px 18px; }
.sk-date { width: 80px; height: 10px; margin-bottom: 8px; }
.sk-line { height: 12px; width: 85%; }
@keyframes news-shimmer {
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
}
</style>
